/**
 * MessageSkeleton - Loading placeholder for messages
 */

interface MessageSkeletonProps {
  count?: number
}

export function MessageSkeleton({ count = 3 }: MessageSkeletonProps) {
  return (
    <div className="space-y-6 animate-pulse">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index}>
          {/* Alternate between user and assistant style */}
          {index % 2 === 0 ? (
            // User message skeleton
            <div className="flex justify-end">
              <div className="max-w-[70%]">
                <div className="bg-gray-200 dark:bg-dark-border rounded-2xl px-4 py-3">
                  <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-48" />
                </div>
              </div>
            </div>
          ) : (
            // Assistant message skeleton
            <div className="flex gap-3">
              {/* Avatar */}
              <div className="w-8 h-8 rounded-full bg-gray-200 dark:bg-dark-border" />

              {/* Content */}
              <div className="flex-1 space-y-2">
                {/* Agent name */}
                <div className="h-4 bg-gray-200 dark:bg-dark-border rounded w-16" />

                {/* Message lines */}
                <div className="space-y-2">
                  <div className="h-4 bg-gray-200 dark:bg-dark-border rounded w-full" />
                  <div className="h-4 bg-gray-200 dark:bg-dark-border rounded w-5/6" />
                  <div className="h-4 bg-gray-200 dark:bg-dark-border rounded w-4/6" />
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default MessageSkeleton
